import {
  enum_,
  type InferOutput,
  number,
  object,
  optional,
  string
} from 'valibot'

import { TRUCK_CLASS_IMPORT_JOB_STATUS_TYPE } from '@/libs/api/types'

/**
 * 車格のインポート履歴の検索条件
 */
export const truckClassImportJobsSearchSchema = object({
  dcId: optional(number()),
  page: optional(number()),
  /** インポートステータス */
  status: optional(enum_(TRUCK_CLASS_IMPORT_JOB_STATUS_TYPE)),
  /** ファイル名 */
  fileName: optional(string())
})

export type TruckClassImportJobsSearch = InferOutput<
  typeof truckClassImportJobsSearchSchema
>
